var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markup-quiz"},_vm._l((_vm.questions),function(question,index){return _c('div',{key:("quiz-" + index)},[_c('question',{attrs:{"question":question}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }